const initialState = {
    email: '',
    subject: '',
    content: '',
    body: '',
};

export default initialState;
